const burger = document.querySelector('.burger');
const menu = document.querySelector('.nav');
const header = document.querySelector('.header');

burger.addEventListener('click', () => {
  burger.classList.toggle('burger--active');
  menu.classList.toggle('nav--active');
  header.classList.toggle('header--active');
});
